/* import __COLOCATED_TEMPLATE__ from './upsell-content-card.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
// eslint-disable-next-line dashboard/use-utilities-window
import theWindow from 'ember-window-mock';
export let State = /*#__PURE__*/function (State) {
  State[State["GetStarted"] = 0] = "GetStarted";
  State[State["LearnMore"] = 1] = "LearnMore";
  State[State["Error"] = 2] = "Error";
  return State;
}({});
const TOS_LINK = 'https://squareup.com/campaign/instant-payouts-terms';
let BankingInstantPayoutsUpsell = (_class = class BankingInstantPayoutsUpsell extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _defineProperty(this, "State", State);
  }
  get state() {
    // TODO @jmah: state will be determined from calling endpoint
    return this.args.state ?? State.GetStarted;
  }
  get termsOfService() {
    switch (this.state) {
      case State.GetStarted:
        return this.intl.t('banking.instantPayouts.settings.content.tos.getStarted', {
          termsOfServiceLink: TOS_LINK,
          htmlSafe: true
        });
      case State.LearnMore:
        return this.intl.t('banking.instantPayouts.settings.content.tos.learnMore', {
          termsOfServiceLink: TOS_LINK,
          htmlSafe: true
        });
      case State.Error:
        return null;
    }
  }
  get description() {
    switch (this.state) {
      case State.GetStarted:
      case State.LearnMore:
        return this.intl.t('banking.instantPayouts.settings.content.description');
      case State.Error:
        return this.intl.t('banking.instantPayouts.settings.content.error.description');
    }
  }
  get heading() {
    switch (this.state) {
      case State.GetStarted:
      case State.LearnMore:
        return this.intl.t('banking.instantPayouts.settings.content.heading');
      case State.Error:
        return this.intl.t('banking.instantPayouts.settings.content.error.heading');
    }
  }
  get buttonCta() {
    switch (this.state) {
      case State.GetStarted:
        return this.intl.t('banking.instantPayouts.settings.content.button.getStarted');
      case State.LearnMore:
        return this.intl.t('banking.instantPayouts.settings.content.button.learnMore');
      case State.Error:
        return this.intl.t('banking.instantPayouts.settings.content.error.button.refreshPage');
    }
  }
  get isCtaButtonLoading() {
    return this.args.isOnboarding;
  }
  onCtaClick() {
    switch (this.state) {
      case State.GetStarted:
        this.args.onGetStartedClick();
        break;
      case State.LearnMore:
        this.args.onLearnMoreClick();
        break;
      case State.Error:
        theWindow.location.reload();
        break;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onCtaClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCtaClick"), _class.prototype), _class);
export { BankingInstantPayoutsUpsell as default };